import axios from "axios";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { Notification, ElMessage, ElMessageBox } from "element-plus";
let fileName = "";
import store from "../store";
import jsonBigint from "json-bigint";

const router = useRouter();
const service = axios.create({
  baseURL: "/api/operate",
  timeout: 6000000,
  // 解决浏览器在ID超过16位精度丢失问题
  transformResponse: [
    function (data) {
      const json = jsonBigint({
        storeAsString: true,
      });
      const res = json.parse(data);
      return res;
    },
  ],
  header: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

service.interceptors.request.use(
  async (config) => {
    config.headers = {
      ...config.headers,
    };
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      // config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["Zh-Token"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (
      config.type === "formData" &&
      config.data &&
      config.data.constructor != FormData
    ) {
      var data = new FormData();
      for (var key in config.data) {
        var val = config.data[key];
        if (val === null || val === undefined) {
          data.append(key, "");
        } else if (val.constructor == Array) {
          for (var i = 0; i < val.length; i++) {
            data.append(
              key,
              typeof val[i] == "object" ? JSON.stringify(val[i]) : val[i]
            );
          }
        } else {
          data.append(key, typeof val == "object" ? JSON.stringify(val) : val);
        }
      }
      config.data = data;
    }
    // config.headers['deptIds'] = localStorage.getItem('deotId')
    // get请求映射params参数
    // if (config.method === 'get' && config.params) {
    //   let url = config.url + '?' + tansParams(config.params)
    //   url = url.slice(0, -1)
    //   config.params = {}
    //   config.url = url
    // }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    // 获取响应头信息中的附件名字 start
    let resType = res.headers["content-type"];
    if (resType != undefined && resType.includes("octet-stream")) {
      const disposition = res.headers["content-disposition"];
      fileName = disposition.split("filename=")[1].replace(/\\"/g, "");
      fileName = decodeURI(escape(fileName));
    }
    // 获取响应头信息中的附件名字 end
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    if (code === 401) {
      ElMessageBox.confirm(
        "登录状态已过期，您可以继续留在该页面，或者重新登录",
        "系统提示",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          console.log("重新登录");
          location.href = "/login";
        })
        .catch(() => {});
      // return Promise.reject('令牌验证失败')
    } else if (code == 500) {
      if (
        res.data.msg == "验证码错误" ||
        res.data.msg == "用户不存在或密码错误"
      ) {
        console.log("用户不存在或密码错误");
      } else if (res.data.msg.indexOf("用户名或密码错误") > -1) {
        console.log("用户名或密码错误");
      } else {
        ElMessage({
          dangerouslyUseHTMLString: true,
          message: res.data.msg,
          type: "error",
        });
      }
      return Promise.reject(new Error(msg));
    } else if (code == 409) {
      ElMessage({
        message: res.data.msg,
        type: "warning",
        duration: 4000,
      });
      return Promise.reject("error");
    } else if (code == 400 || code == 403) {
      ElMessage({
        message: res.data.msg,
        type: "warning",
      });
      return Promise.reject("error");
    } else if (code != 2000) {
      if (code.indexOf("B.F-") != -1) {
        ElMessage({
          message: res.data.message,
          type: "error",
        });
        return Promise.reject("error");
      } else {
        ElMessage({
          message: "系统内部错误，请联系管理员",
          type: "error",
        });
        return Promise.reject("error");
      }
    } else {
      return res.data;
    }
  },
  (error) => {
    if (error.response) {
      const data = error.response.data;
      const errCode = data.code;
    }
    return Promise.reject(error);
  }
);

export default service;
